import { combineReducers } from 'redux';
import loginReducer from './login/LoginReduecer';
import basicDetailsReducer from './BasicDetails/BasicDetailReducer';
import requestListDataReducer from './requestList/requestListReducer';
import requestDetailReducer from './requestDetail/requestDetailReducer';
import patientListReducer from './patientList/patientLIstReducer';
import deletepatientListReducer from './patientListDelete/patientListDeleteReducer';
import patientDetailReducer from './patientDetail/patientDetailReducer';
import providerListReducer from './providerList/providerListReducer';
import patientStatusReducer from './providerStatus/providerStatusReducer';
import providerDetailReducer from './providerDetail/providerDetailReducer';
import profileDataReducer from './AdminProfile/AdminProfileReducer';
import adminLogoutReducer from './AdminLogout/AdminLogoutReducer';
import requestPostReducer from './requestPost/requestPostReducer';
import adminDashboardReducer from './AdminDashboard/AdminDashboardReducer';
import getPracticeListReducer from './getPracticeList/getPracticeListReducer';
import getSubPracticeListReducer from './getSubPracticeList/getSubpracticeListReducer';
import getPracticeDetailReducer from './getPracticeDetail/getPracticeDetailReducer';
import getSymptomsListReducer from './symptomsList/symptomsListReducer';
import deletePracticeListReducer from './practiceDetelet/practiceDeteletReducer';
import basicDetailsValueReducer from './BasicDetailaAllValue/BasicDetailValueReducer';
import getPracticeReducer from './practiceList/practiceListReducer';
import getSubPracticeDetailReducer from './getSubPracticeDetail/getSubPracticeDetailReducer';
import createPracticeReducer from './createPractice/createPracticeReducer';
import createSubPracticeReducer from './createSubPractice/createSubPracticeReducer';
import updateSubPracticeReducer from './updateSubPractice/updateSubPracticeReducer';
import updatePracticeReducer from './updatePractice/updatePracticeReducer';
import deleteSubPracticeListReducer from './subPracticeDelete/subPracticeDeleteReducer';
import questionnaireListDataReducer from './QuestionnaireList/QuestionnaireListReducer';
import getCategoryListDataReducer from './categoryList/categoryListReducer';
import getMasterDataReducer from './masterData/masterdataReducer';
import postQuestionReducer from './createQuestion/createQuestionReducer';
import deleteQuestionnairListReducer from './questionnaireDelete/questionnaireDeleteReducer';
import { getQuestionDetailData } from './questionDetail/questionDetailAction';
import updateQuestionReducer from './updateQuestion/updateQuestionReducer';
import postQuestionnaireReducer from './createQuestionnaire/createQuestionnaireReducer';
import getQuestionnaireDetailData from './getQestionnaireDetail/getQuestionnaireDetailReducer';
import updateQuestionnaireReducer from './updateQuestionnaire/updateQuestionnaireRecuder';
import UploadReducer from './profileUpload/profileUploadReducer';
import updateProfileSectionDataReducer from './updateDoctorProfile/updateDoctorProfileReducer';
import getDoctorDropReducer from './getDoctorListDropdown/getDoctorListDropdownReducer';
import getProductListReducer from './getProductList/reducer';
import getTermsPrivacyDataReducer from './getTerms&Privacy/reducer';
import postTermsPrivacyDataReducer from './postTerms&Privacy/reducer';
import deleteProfessionalListReducer from './deleteProfessional/deleteProfessionalReducer';
import getAllCategoryListReducer from './getAllCategoryList/reducer';
import adminOtpVerifyReducer from './AdminOtpVerify/AdminOtpVerifyReducer';
import getPendingAppointmentsListReducer from './pendingAppointments/pendingAppointmentListReducer';
import internalDoctorReducer from './internalDoctor/internalDoctorReducer';
import getConsultationHistoryReducer from './getConsultationHistory/getConsultationHistoryReducer';
import updateDoctorEarningReducer from './updateDoctorEarning/updateDoctorEarningReducer';
import downloadConsultationHistoryReducer from './downloadConsultationHistory/downloadConsultationHistoryReducer';
import getSubscriptionListReducer from './getSubscriptionList/reducer';
import addSubscriptionPurchaseReducer from './addSubscriptionPurchase/reducer';
import getImpressionsListReducer from './getImpressions/reducer';
import getRevenueListReducer from './getRevenueStream/reducer';
import getScanAnalysisReducer from './getScanAnalysis/reducer';
import getScannedMaskReducer from './getScannedMask/reducer';
import getScannedImageReducer from './getScannedImage/reducer';
import getFaceBatchResultReducer from './getFaceBatchResult/reducer';
import getEnterpriseReducer from './Enterprise/enterprise/getEnterprise/reducer';
import createEnterpriseReducer from './Enterprise/enterprise/createEnterprise/reducer';
import deleteEnterpriseReducer from './Enterprise/enterprise/deleteEnterprise/reducer';
import updateEnterpriseReducer from './Enterprise/enterprise/updateEnterprise/reducer';
import getParticularEnterpriseReducer from './Enterprise/enterprise/getParticularEnterprise/reducer';
import getStaffReducer from './Enterprise/staff/getStaff/reducer';
import createStaffReducer from './Enterprise/staff/createStaff/reducer';
import getLocationReducer from './Enterprise/enterprise/getLocation/reducer';
import resendInviteReducer from './Enterprise/staff/resendInvite/reducer';
import getEnterpriseScannedImageReducer from './Enterprise/staff/getEnterpriseScannedImage/reducer';
import getEnterpriseProfileReducer from './EnterpriseAdmin/enterpriseProfile/reducer';
import createLocationReducer from './EnterpriseAdmin/Location/createLocation/reducer';
import updateLocationReducer from './EnterpriseAdmin/Location/updateLocation/reducer';
import deleteLocationReducer from './EnterpriseAdmin/Location/deleteLocation/reducer';
import getLeadCaptureReducer from './LeadCapture/getLeadCapture/reducer';
import getLeadCaptureDetailReducer from './LeadCapture/getLeadCaptureDetail/reducer';
import downloadLeadCaptureReducer from './LeadCapture/downloadLeadCapture/reducer';
import deleteLeadCaptureReducer from './LeadCapture/deleteLeadCapture/reducer';
import leadCaptureDropdownReducer from './LeadCapture/leadCaptureDropdown/reducer';
import createLeadCaptureReducer from './LeadCapture/createLeadCapture/reducer';
import updateLeadCaptureReducer from './LeadCapture/updateLeadCapture/reducer';
import getEnterpriseProductReducer from './EnterpriseAdmin/Product/getEnterpriseProduct/reducer';
import getSkinConcernsReducer from './EnterpriseAdmin/Product/getSkinConcerns/reducer';
import getSkinTypesReducer from './EnterpriseAdmin/Product/getSkinTypes/reducer';
import validateTokenReducer from './validateToken/reducer';
import setPasswordReducer from './setPassword/reducer';
import resendEnterpriseInviteReducer from './Enterprise/enterprise/resendEnterpriseInvite/reducer';

export default combineReducers({
  basicDetailsReducer,
  loginReducer,
  basicDetailsValueReducer,
  UploadReducer,
  profileDataReducer,
  adminDashboardReducer,
  getDoctorDropReducer,
  requestListDataReducer,
  requestDetailReducer,
  requestPostReducer,
  patientListReducer,
  deletepatientListReducer,
  patientDetailReducer,
  providerListReducer,
  updateProfileSectionDataReducer,
  patientStatusReducer,
  providerDetailReducer,
  deleteProfessionalListReducer,
  getPracticeListReducer,
  getSymptomsListReducer,
  getPracticeDetailReducer,
  createPracticeReducer,
  updatePracticeReducer,
  deletePracticeListReducer,
  getSubPracticeListReducer,
  getSubPracticeDetailReducer,
  getPracticeReducer,
  createSubPracticeReducer,
  updateSubPracticeReducer,
  deleteSubPracticeListReducer,
  questionnaireListDataReducer,
  deleteQuestionnairListReducer,
  getMasterDataReducer,
  getCategoryListDataReducer,
  postQuestionReducer,
  getQuestionDetailData,
  updateQuestionReducer,
  postQuestionnaireReducer,
  getQuestionnaireDetailData,
  updateQuestionnaireReducer,
  adminLogoutReducer,
  getProductListReducer,
  getTermsPrivacyDataReducer,
  postTermsPrivacyDataReducer,
  getAllCategoryListReducer,
  adminOtpVerifyReducer,
  getPendingAppointmentsListReducer,
  internalDoctorReducer,
  getConsultationHistoryReducer,
  updateDoctorEarningReducer,
  downloadConsultationHistoryReducer,
  getSubscriptionListReducer,
  addSubscriptionPurchaseReducer,
  getImpressionsListReducer,
  getRevenueListReducer,
  getScanAnalysisReducer,
  getScannedMaskReducer,
  getScannedImageReducer,
  getFaceBatchResultReducer,
  getEnterpriseReducer,
  createEnterpriseReducer,
  deleteEnterpriseReducer,
  updateEnterpriseReducer,
  getParticularEnterpriseReducer,
  getStaffReducer,
  createStaffReducer,
  getLocationReducer,
  resendInviteReducer,
  getEnterpriseScannedImageReducer,
  getEnterpriseProfileReducer,
  createLocationReducer,
  updateLocationReducer,
  deleteLocationReducer,
  getLeadCaptureReducer,
  getLeadCaptureDetailReducer,
  downloadLeadCaptureReducer,
  deleteLeadCaptureReducer,
  leadCaptureDropdownReducer,
  createLeadCaptureReducer,
  updateLeadCaptureReducer,
  getEnterpriseProductReducer,
  getSkinConcernsReducer,
  getSkinTypesReducer,
  validateTokenReducer,
  setPasswordReducer,
  resendEnterpriseInviteReducer,
});
